import { z } from 'zod'

export const paymentSchema = z.object({
  cardNumber: z.string().min(1, '必須項目です'),
  cardHolder: z.string().min(1, '必須項目です'),
  expirationMonth: z.string().min(1, '必須項目です'),
  expirationYear: z.string().min(1, '必須項目です'),
  securityCode: z.string().min(1, '必須項目です'),
  paymentToken: z.string(),
  maskedCardNo: z.string(),
  toBeExpiredAt: z.string(),
})

export const updateProfileSchema = z.object({
  lastName: z
    .string()
    .min(1, '苗字を入力してください')
    .max(50, '苗字は50文字以内で入力してください'),
  firstName: z
    .string()
    .min(1, '名前を入力してください')
    .max(50, '名前は50文字以内で入力してください'),
  lastNameKana: z
    .string()
    .min(1, '苗字のフリガナを入力してください')
    .max(50, '苗字のフリガナは50文字以内で入力してください'),
  firstNameKana: z
    .string()
    .min(1, '名前のフリガナを入力してください')
    .max(50, '名前のフリガナは50文字以内で入力してください'),
  tel: z
    .string()
    .min(1, '電話番号を入力してください')
    .regex(
      /^0\d{9,10}$/,
      '正しい電話番号を入力してください（例: 09012345678）'
    ),
})

export const addressSchema = z.object({
  lastName: z.string().min(1, '姓は必須項目です'),
  firstName: z.string().min(1, '名は必須項目です'),
  lastNameKana: z.string().min(1, 'セイは必須項目です'),
  firstNameKana: z.string().min(1, 'メイは必須項目です'),
  zip: z
    .string()
    .refine(
      (val) => /^(\d{3}-\d{4}|\d{7})$/.test(val),
      '正しい郵便番号形式で入力してください'
    )
    .transform((val) => {
      if (/^\d{7}$/.test(val)) {
        return val.slice(0, 3) + '-' + val.slice(3)
      }
      return val
    }),
  prefecture: z.string().min(1, '都道府県は必須項目です'),
  city: z.string().min(1, '市区町村は必須項目です'),
  street: z.string().min(1, '町名・番地は必須項目です'),
  building: z.string().optional(),
  tel: z.string().regex(/^\d{10,11}$/, '正しい電話番号形式で入力してください'),
  isPrimary: z.boolean().optional(),
})
